import { Injectable } from '@angular/core';

import { LoggerFactory, SportsRemoteLogger } from '@frontend/sports/common/core/feature/logging';
import { ModalDialogService } from '@frontend/sports/modal/feature';
import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { PayoutAcceptanceMode } from '@frontend/sports/types/models/user-settings';
import { EarlyPayoutAcceptance, SyncUserSettingsService, UserSettingsService } from '@frontend/sports/user/feature';
import { LoadingIndicatorService } from '@frontend/vanilla/core';

import { MyBetsEarlyPayoutTacDialogComponent } from './tac-dialog.component';

@Injectable({ providedIn: 'root' })
export class MyBetsEarlyPayoutTacService {
    private readonly logger: SportsRemoteLogger;

    constructor(
        loggerFactory: LoggerFactory,
        private modalDialog: ModalDialogService,
        private loadingIndicator: LoadingIndicatorService,
        private userSettings: UserSettingsService,
        private tracker: TrackingService,
        private userSettingsService: SyncUserSettingsService,
    ) {
        this.logger = loggerFactory.getLogger('MyBetsEarlyPayoutTacService');
    }

    get isEarlyPayoutTac(): boolean {
        return (
            this.userSettingsService.bettingSettings.earlyPayoutAcceptanceMode === PayoutAcceptanceMode.AcceptAnyChanges ||
            this.userSettingsService.bettingSettings.earlyPayoutAcceptanceMode === PayoutAcceptanceMode.AcceptHigherPayoutAmount
        );
    }

    async showTacDialog(betslipContainsLiveBets: boolean, betsListContextIsEventView: boolean): Promise<boolean> {
        const dialog = this.modalDialog.openDialog(MyBetsEarlyPayoutTacDialogComponent, {
            settings: { showDialogHeader: true, cssClass: 'early-payout-tac-dialog' },
        });
        try {
            const accepted = await dialog.result;
            if (accepted) {
                return await this.earlyPayoutTacAccepted(betslipContainsLiveBets, betsListContextIsEventView);
            }

            return false;
        } catch {
            return false;
        }
    }

    private async earlyPayoutTacAccepted(betslipContainsLiveBets: boolean, betsListContextIsEventView: boolean): Promise<boolean> {
        const loadingIndicator = this.loadingIndicator.start();
        const context = betsListContextIsEventView ? '_eventView' : '_myBets';
        try {
            await this.userSettings.set({ earlyPayoutAcceptanceMode: EarlyPayoutAcceptance.Higher });
            this.tracker.track(trackingConstants.EVENT_PAGE_VIEW, {
                [trackingConstants.PAGE_NAME]:
                    (betslipContainsLiveBets ? 'LIVE/EarlyPayout_TCSuccessful' : 'MAIN/EarlyPayout_TCSuccessful') + context,
            });
            loadingIndicator.done();

            return true;
        } catch (error) {
            this.tracker.track(trackingConstants.EVENT_PAGE_VIEW, {
                [trackingConstants.PAGE_NAME]: (betslipContainsLiveBets ? 'LIVE/EarlyPayout_TCError' : 'MAIN/EarlyPayout_TCError') + context,
            });
            this.logger.error(error, 'Failed to accept Early payout TAC');

            return false;
        }
    }
}
